"use client";

/**
 * `<BillingToggle>` — segmented Monthly / Annual control.
 *
 * Per dispatch Phase 5: shows a "Save 17%" badge on the Annual option
 * (Reports Pro saves ~17%; Compass Pro and Premium save ~17% each, so
 * the single label fits both sections).
 */

export type Billing = "monthly" | "annual";

interface BillingToggleProps {
  value: Billing;
  onChange: (next: Billing) => void;
  savePercent?: number;
}

const OPTIONS: Billing[] = ["monthly", "annual"];

export function BillingToggle({
  value,
  onChange,
  savePercent = 17,
}: BillingToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Billing cadence"
      style={{
        display: "inline-flex",
        padding: 4,
        background: "rgba(255,255,255,0.03)",
        border: "1px solid var(--color-line)",
        borderRadius: 999,
        gap: 2,
      }}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt;
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt)}
            style={{
              padding: "7px 16px",
              fontSize: 13,
              borderRadius: 999,
              fontWeight: 500,
              background: active ? "var(--color-text)" : "transparent",
              color: active ? "var(--color-bg)" : "var(--color-muted)",
              transition: "all 0.2s",
              border: "none",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            {opt[0]?.toUpperCase() + opt.slice(1)}
            {opt === "annual" ? (
              <span
                style={{
                  fontSize: 10,
                  padding: "2px 6px",
                  borderRadius: 3,
                  background: active
                    ? "rgba(16,185,129,0.15)"
                    : "rgba(16,185,129,0.10)",
                  color: "var(--color-green)",
                  fontFamily: "var(--font-mono)",
                  letterSpacing: "0.1em",
                  fontWeight: 600,
                }}
              >
                SAVE {savePercent}%
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
